export const environment = {
  basePath: import.meta.env.BASE_URL,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  otamaRegistrationEndpoint: import.meta.env.VITE_OTAMA_REGISTRATION_ENDPOINT ?? '',
  otamaRegistrationPlace: import.meta.env.VITE_OTAMA_REGISTRATION_PLACE ?? '',
  otamaDeviceLabel: import.meta.env.VITE_OTAMA_DEVICE_LABEL ?? 'KIOSKO WEB',
  cloudflareEnvironment: import.meta.env.VITE_CLOUDFLARE_ENV ?? 'production',
  appVersion: __APP_VERSION__,
};
